// extracted by mini-css-extract-plugin
export var hideEditor = "_iw-2";
export var infoIcon = "_iw-3";
export var label = "_iw-1";
export var labelContainer = "_iw-0";
export var readonlyText = "_iw-4";